import { Toast as OSToast } from '@vivo/vos-ui'
import { Toast } from '@vivo/shop-ui-h5'
import env from './clientEnv'
import { getCookie, stopWinScroll } from './common'
import setShareConfig from './share'
import config from '@/config'

// flag 大于小于
const checkVersion = (number, flag) => {
  if (!flag) {
    return env.isVivoApp && env.appVersion >= number
  } else {
    return env.isVivoApp && env.appVersion < number
  }
}

// 配合客户端适配英文双引号json报错场景
const replaceStr = (str) => {
  return str.replace(/"/g, '\\\"')
}
// 调用客户端不存的方法时，回调此方法
window._NotCompatiblityHandler_ = function () {
  //可为空
}

export default {
  checkVersion(number, flag) {
    return checkVersion(number, flag)
  },
  /**
   * 登录, v >= 100
   * @param {string} callbackPath 登录后需要跳转的url
   */
  login() {
    let url = window.location.href
    if (env.isVivoApp || env.isIOSVivoApp) {
      // 如果是官网app,则调用app登录功能
      localStorage.setItem('redirect_uri', url)
      window.vivospace.login('https://shop.vivo.com.cn/wap/my/login')
    } else {
      env.isWeChatApp().then(res => {
        // 小程序
        if (res) {
          // eslint-disable-next-line
          // wx.miniProgram.navigateTo({ url: '/pages/shop/login/index' })
          window.location.href = `https://passport.vivo.com.cn/v3/web/login/authorize?client_id=3&redirect_uri=${encodeURIComponent(
            url
          )}`
        } else {
          // 除官网app和小程序之外的情况
          localStorage.setItem('redirect_uri', url)
          window.location.href = `https://passport.vivo.com.cn/v3/web/login/authorize?client_id=3&redirect_uri=${encodeURIComponent(
            'https://shop.vivo.com.cn/wap/my/login'
          )}`
        }
      })
    }
  },

  /**
   * 更新购物车数量, v >= 100
   */
  updateCartNum({ error }) {
    if (env.isVivoApp && !env.isIOSVivoApp && env.appVersion >= 172) {
      window.vivospace.shopCartRefresh(parseInt(getCookie('shop_cart_num')) || 0)
    } else {
      error && error()
    }
  },

  /**
   * 通知app收藏数量, v >= 172
   * @param {number} num 收藏数量
   */
  refreshFavoriteNum(num) {
    if (env.isVivoApp && env.appVersion >= 172) {
      window.WeiwoJSBridge.call('shopCollectionCount', {
        count: num || 0
      })
    }
  },

  /**
   * 通知app可用优惠券数量, v >= 172
   * @param {number} num 可用优惠券数量
   */
  refreshCouponCount(num) {
    if (env.isVivoApp && env.appVersion >= 172) {
      window.WeiwoJSBridge.call('shopCouponCount', {
        count: num || 0
      })
    }
  },

  /**
   * 唤起联系人， v >= 190
   * @param {function} callback 选择联系人之后执行的回调函数
   */
  pickContact(callback) {
    if (env.isVivoApp && env.appVersion >= 190) {
      const callbackName = `contactCBName${Date.now()}`

      window[callbackName] = function (...args) {
        if (args.length === 1) {
          callback(...args[0].split(','))
        } else {
          callback(...args)
        }
      }
      window.vivospace.pickContact(callbackName)
    }
  },

  /**
   * 提交订单通知官网app，更新数字或者红点, v >= 300
   */
  refreshOrder() {
    window.WeiwoJSBridge.call('submitOrderSucess', {})
  },

  /**
   * 通知app代付款订单, v >= 300
   * @param {number} num 收藏数量
   */
  refreshWaitForPayNum(num) {
    if (env.isVivoApp && env.appVersion >= 300) {
      window.WeiwoJSBridge.call('shopWaitingForPayNum', {
        count: num || 0
      })
    }
  },

  /**
   * 通知客户端刷新订单列表, v >= 4000
   * @param {number} num 收藏数量
   */
  refreshOrderNum() {
    if (env.isVivoApp && env.appVersion >= 4000) {
      window.WeiwoJSBridge.call('refreshSpaceOrderList', {})
    }
  },
  /**
   * 调用图片查看器
   *
   * 查看评价大图, v >= 310
   * browse: {
   *    images: [], // 数组则是多图查看，图片url数组，
   *    imageIndex: 0 // 索引
   * }
   *
   * 查看大图，带评价内容, v >= 920
   * browse: {
   *    images: [], // 数组则是多图查看，图片url数组，
   *    imageIndex: 0 // 索引
   *    isRate: true,
   *    estimate: remark.content, //评价内容
   *    icon: remark.memberAvatar, // 用户图像
   *    rate: remark.summaryScore, // 评价分数
   *    time: remark.createdAt, // 评价时间
   *    nick: remark.createdBy, // 昵称
   *    memberLever: remark.memberLever, // 会员等级
   *    memberLeverName: remark.memberLeverName // 会员等级名
   * }
   */
  remarkShowBigImage(picSrcs, index, remark, remarkLoadedInfo) {
    let flag = false
    if (env.isVivoApp && !env.isIOSVivoApp) {
      let imagesList = []
      let videoAndImagesList = []
      // 图片与视频格式封装，兼容新老版客户端
      picSrcs.forEach(item => {
        if (typeof item == 'object') {
          imagesList.push(item.videoPoster)
          videoAndImagesList.push({ imageUrl: item.videoPoster, videoUrl: item.videoUrl })
        } else {
          if (item.indexOf(';base64,') > -1) {
            item = encodeURIComponent(item)
          }
          imagesList.push(item)
          videoAndImagesList.push({ imageUrl: item })
        }
      })
      if (env.appVersion >= 920 && remark) {
        // 评价图片无限循环
        if (env.appVersion >= 3700) {
          let remarkLoadedParam = {}
          let remarkLoadedParam2 = {}
          if (remarkLoadedInfo) {
            remarkLoadedParam = JSON.parse(JSON.stringify(remarkLoadedInfo))
            remarkLoadedParam2 = JSON.parse(JSON.stringify(remarkLoadedInfo))
            remarkLoadedParam.remarkPreviewList.forEach(item => {
              if (item.content) {
                item.content = encodeURIComponent(
                  replaceStr(item.content.replace(/<[^>]+>|&nbsp;/g, ''))
                )
              } else {
                item.content = ''
              }

              item.nickName = encodeURIComponent(replaceStr(item.nickName))
              item.skuName = encodeURIComponent(item.skuName)
              item.specItem = encodeURIComponent(item.specItem)
              // 移除官方回复和追评
              delete item.commentAppendDto
              delete item.commentReplyDtos
            })
          }
          window.showShopCommentImageInfo = {
            browse: {
              images: imagesList,
              videoAndImages: videoAndImagesList,
              imageIndex: index,
              isRate: true,
              estimate: remark.content || '',
              icon: remark.memberAvatar,
              rate: remark.summaryScore,
              time: remark.createdAt,
              nick: remark.createdBy || '',
              memberLever: remark.memberLever,
              memberLeverName: remark.memberLeverName,
              specItem: remark.specItem || '',
              ...remarkLoadedParam2
            }
          }
          window.WeiwoJSBridge.call('viewDetailImages', {
            browse: {
              images: imagesList,
              videoAndImages: videoAndImagesList,
              imageIndex: index,
              isRate: true,
              estimate: remark.content ? encodeURIComponent(replaceStr(remark.content.replace(/<[^>]+>|&nbsp;/g, ''))) : '',
              icon: remark.memberAvatar,
              rate: remark.summaryScore,
              time: remark.createdAt,
              nick: remark.createdBy ? encodeURIComponent(replaceStr(remark.createdBy)) : '',
              memberLever: remark.memberLever,
              memberLeverName: remark.memberLeverName,
              specItem: encodeURIComponent(remark.specItem ? remark.specItem : ''),
              ...remarkLoadedParam
            }
          })
        } else {
          window.WeiwoJSBridge.call('viewShopImages', {
            browse: {
              images: imagesList,
              imageIndex: index,
              isRate: true,
              estimate: remark.content ? encodeURIComponent(replaceStr(remark.content.replace(/<[^>]+>|&nbsp;/g, ''))) : '',
              icon: remark.memberAvatar,
              rate: remark.summaryScore,
              time: remark.createdAt,
              nick: remark.createdBy ? encodeURIComponent(replaceStr(remark.createdBy)) : '',
              memberLever: remark.memberLever,
              memberLeverName: remark.memberLeverName
            }
          })
        }

        flag = true
      } else if (env.appVersion >= 310) {
        window.WeiwoJSBridge.call('viewShopImages', {
          browse: {
            images: imagesList,
            imageIndex: index
          }
        })
        flag = true
      }
    }
    return flag
  },
  /**
   * 查看镭雕，多图叠加为一张图查看, v > 310
   * laser: {
   *    mainImage: '', // 字符串：底图url
   *    overImages: [] // 数组：叠加图url
   *}
   * @param {object} params 形如｛ browse: {} }
   */
  viewImgs(params = {}) {
    if (env.isVivoApp && env.appVersion >= 310 && !env.isIOSVivoApp) {
      window.WeiwoJSBridge.call('viewShopImages', params)
      return true
    } else {
      return false
    }
  },

  /**
   * 新人礼包通知app, v >= 600
   * 00 待领取 01 领取成功 02 已领取 03 活动已过期 08 领取失败 09 无权领取
   * @param {string} status 礼包状态
   */
  refreshUserGiftBags(status) {
    if (env.isVivoApp && env.appVersion >= 600) {
      window.WeiwoJSBridge.call('shopNewBagReceiveResult', {
        result: true,
        bagStatus: status
      })
    }
  },

  /**
   * 网络环境提示, v >= 920
   * @param {function} callback 获取网络状态之后的回掉，网络状态对象作为第一个参数传入, true 为移动网络
   */
  isMobileNet(callback) {
    window.WeiwoJSBridge.call('netWorkStatus', '', function (value) {
      let result = JSON.parse(value)
      callback(result.isMobile)
    })
  },

  /**
   * 分享海报, v >= 920
   * @param {string} imageUrl 海报图片url
   * @param {string} shareTitle 分享标题
   */
  sharePoster({ imageUrl, shareTitle, finishCallBack }, callback) {
    window.WeiwoJSBridge.call(
      'shareImage',
      {
        imageUrl,
        shareTitle,
        finishCallBack,
        isSharePoster: true
      },
      function (value) {
        callback(value)
      }
    )
  },

  /**
   * native titlebar显示隐藏切换, v >= 920
   * @param {boolean} isShow true为显示，false为不显示, delay： 是否延迟，因为弹框有渐出的效果，避免开始就隐藏头部
   */
  toggleTitleBar({ isShow, error, delay }) {
    if (checkVersion(920)) {
      setTimeout(
        function () {
          window.WeiwoJSBridge.call('shopDetailNavShow', {
            isShow
          })
        },
        delay && !isShow ? 260 : 0
      )
    } else {
      error && error()
    }
    stopWinScroll(!isShow)
  },

  /**
   * native titlebar显示隐藏切换, v >= 920
   * @param {boolean} isShow true为显示，false为不显示, delay： 是否延迟，因为弹框有渐出的效果，避免开始就隐藏头部
   */
  toggleTitleBarNew({ isShow, error, delay }) {
    if (checkVersion(920) && !env.isDefaultHideTitle) {
      setTimeout(
        function () {
          window.WeiwoJSBridge.call('shopDetailNavShow', {
            isShow
          })
        },
        delay && !isShow ? 260 : 0
      )
    } else {
      error && error()
    }
    stopWinScroll(!isShow)
  },

  shopDetailNavShow(isShow) {
    if (checkVersion(920)) {
      window.WeiwoJSBridge.call('shopDetailNavShow', {
        isShow
      })
    }
  },

  /**
   * native titlebar模式切换（两套菜单不同的titlebar), v >= 920
   * @param {number} mode 0 精简， 1 含tab头
   */
  setTitleBarMode({ mode, error }) {
    if (checkVersion(920)) {
      window.WeiwoJSBridge.call('shopDetailNavMode', {
        mode
      })
    } else {
      error && error()
    }
  },

  /**
   * native 设置titlebar索引
   * @param {index}
   */
  setTitleBarIndex({ index, error }) {
    if (checkVersion(920)) {
      window.WeiwoJSBridge.call('shopDetailNavPageChange', {
        number: index
      })
    } else {
      error && error()
    }
  },

  /**
   * native titlebar是否显示评价tab, v >= 920
   * @param {boolean} isShow true 显示评价tab， false 不显示评价tab
   */
  isShowTitlebarComment({ isShow, error }) {
    if (checkVersion(920)) {
      window.WeiwoJSBridge.call('shopDetailNavRateShow', {
        isShow
      })
    } else {
      error && error()
    }
  },

  /**
   * 获取系统状态栏高度，适配沉浸式titlebar, v >= 920
   * @param {string} type statusBarHeight 状态栏高度，navBarHeight titlebar高度
   * @param {string} callback 获取高度之后的回调函数，高度对象字符串作为第一个参数传入，形如 JSON.parse(value).statusBarHeight
   */
  getTitleBarHeight({ type, success, error }) {
    if (checkVersion(920) || env.isIOSVivoApp) {
      window.WeiwoJSBridge.call(type, '', function (value) {
        const result = JSON.parse(value)
        success && success(result[type])
      })
    } else {
      error && error()
    }
  },

  /**
   * 设置分享参数分享, v >= 920
   * @param {object} shareInfo
   */
  setShareConfig,

  /**
   * 调起分享
   */
  doShare() {
    window.vivospace && window.vivospace.doshare()
  },

  /**
   * 官网APP返回, v >= 190
   */
  appGoBack() {
    if ((env.isVivoApp && env.appVersion >= 190) || env.isIOSVivoApp) {
      window.WeiwoJSBridge.webBackPress()
    } else {
      window.history.go(-1)
    }
  },

  /**
   * Native收银台, v >= 2100
   * @param {object} paydata
   */
  vivopayByNative({ data, success, error }) {
    if (checkVersion(2100)) {
      // 埋点打点
      if (data.grayTestData) {
        let grayTestData = data.grayTestData
        data.payNativeData.planId = grayTestData.plan_id
        data.payNativeData.testId = grayTestData.test_id
        data.payNativeData.orderId = grayTestData.order_id
      }
      // 结算来源
      data.payNativeData.pageSource = data.type
      window.WeiwoJSBridge.call('vivopayByUnifiedpayment', data.payNativeData)
      window.vivopayByUnifiedpaymentCallback = function (transNo, isSuc, stateCode) {
        if (stateCode == '0') {
          window.location.replace(`${data.payData.return_url}?orderNo=${data.payData.out_trade_no}`)
        } else if (stateCode == '-1002' || stateCode == '-1003') {
          window.location.replace(`/wap/my/order/detail?orderNo=${data.orderNo}&tempTerminal=${data.tempTerminal}`)
        } else {
          if (data.type === 'orderDetail') {
            window.location.replace(`/wap/my/order/detail?orderNo=${data.orderNo}&tempTerminal=${data.tempTerminal}`)
          } else {
            window.location.replace(`/wap/my/order?tempTerminal=${data.tempTerminal}`)
          }
        }
        success && success(isSuc)
      }
    } else {
      error && error()
    }
  },

  /**
   * 通知客户端商品类型
   * @param {string} type
   */
  shopCommodityType(type) {
    try {
      if (checkVersion(1500)) {
        window.WeiwoJSBridge.call('shopCommodityType', {
          commodity_type: type
        })
      }
    } catch (e) { }
  },
  /**
   * 检测用户是否开启了系统通知权限或者app push通知权限，如果未开启权限，则app弹窗引导用户开启统治权限
   * @param {*} id 场景值，1(评论/回复弹层);2(下单后及查看物流弹层);3(抢购弹层);4(发布会弹出);5(新品预定弹层);6(到货通知)
   * @param {string} title 弹窗title
   * @param {string} content 弹窗内容
   */
  checkNotifyAuth({ id, title, content }) {
    const isVersion =
      (env.appVersion >= 3000 && env.appVersion < 6970) || (env.appVersion > 6971 && env.appVersion < 6996)
    if (env.isVivoApp && isVersion) {
      window.WeiwoJSBridge &&
        window.WeiwoJSBridge.call('notificationRecall', {
          id,
          title,
          content
        })
    }
  },
  /**
   * 上报客户端推荐商品埋点
   */
  webDataReportByApp: function (data) {
    try {
      let url = window.location.href
      // 官网app埋点上报
      if (checkVersion(2400) || env.isIOSVivoApp) {
        data.url = url
        data.visittype = 'vivoapp'
        data.cfrom = data.event_id
        data.reportType = '2' // 默认实时上报
        delete data.event_id
        window.WeiwoJSBridge.call('webDataReportByApp', data)
      }
    } catch (e) { }
    return null
  },
  /**
   * 在商详页菜单中不显示在浏览器中打开按钮
   */
  toggleMenuShare(isShow) {
    if (checkVersion(3600)) {
      window.WeiwoJSBridge.call('showShareWeb', {
        is_show: isShow
      })
    }
  },
  /**
   * 设置商详页titlebar标签内容，如果不调用此方法则显示默认的四个，商品，评价，详情，服务
   * commodity_tab: [''tab1'', ''tab2'', ''tab3'']   // 注：最多显示4个，每个tab签名称不能超过3位，传入几个就显示几个
   */
  setDetailPageTitlebar(tabArr = ['商品', '评价', '详情', '服务']) {
    if (checkVersion(3600)) {
      window.WeiwoJSBridge.call('setCommodityTabText', {
        commodity_tab: tabArr
      })
    }
  },

  /**
   * 唤起native分享
   */
  showShare(params, cb) {
    if (checkVersion(2400) || env.isIOSVivoApp) {
      if (params.title) {
        params.title = encodeURIComponent(params.title)
      }
      if (params.summary) {
        params.summary = encodeURIComponent(params.summary)
      }
      cb && cb()
      window.WeiwoJSBridge.call('showShare', params)
    }
  },

  /**
   * 获取客户端GPS定位信息
   */
  getLocation(callback, error) {
    if (checkVersion(2700) || env.isIOSVivoApp) {
      window.WeiwoJSBridge.call('getLocation', '', res => {
        let result = JSON.parse(res)
        callback(result)
      })
    } else {
      error && error()
    }
  },

  /**
   * 获取定位权限
   */
  isPermissionGranted(callback, error) {
    // v9.0.4.2定位弹框特性版本
    if (env.isVivoApp && env.appVersion >= 5302 && !env.isIOSVivoApp) {
      window.WeiwoJSBridge.call(
        'isPermissionGranted',
        {
          code: 'android.permission.ACCESS_COARSE_LOCATION'
        },
        res => {
          let result = JSON.parse(res)
          callback(result.hasPermission)
        }
      )
    } else {
      callback(true)
    }
  },

  /**
   * 通过deeplink打开app，回调打开的结果
   * options: {
   *   deepLink：目标的deeplink链接
   *   packageName：目标包名
   * }
   */
  openAppByDeepLink(options, callback) {
    if (env.isVivoApp && env.appVersion >= 190) {
      window.WeiwoJSBridge.openAppByDeepLink(options, function (res) {
        let result = JSON.parse(res)
        callback && callback(result)
      })
    }
  },
  toast(options, callback) {
    let params = {}
    if (env.isVivoApp && env.appVersion >= 190 && options.type !== 'html') {
      if (typeof options == 'string') {
        params.tips = options
      } else {
        params = options
        if (options.message) {
          params.tips = options.message
        }
      }
      if (params.tips) {
        if (window.top == window.self) {
          window.WeiwoJSBridge.toast(params)
        } else {
          window.top.WeiwoJSBridge.toast(params)
        }
      }
    } else {
      console.log('app.toast', options)
      // 接入公控后对options进行字段处理（tips表示文本内容）
      if (typeof options == 'string') {
        params.tips = options
      } else {
        params = options
        if (options.message) {
          params.tips = options.message
        }
      }
      if (!params.duration && params.duration != 0) {
        params.duration = 2000
      }
      // TODO：公控不支持html，等后续支持后再进行替换
      if (params.tips && options.type == 'html') {
        // 采用原先的toast
        params.message = params.tips
        Toast(params)
      } else {
        // 对于type为success的情况，进行自定义图标设置
        if (options.type == 'success') {
          params.img =
            window.matchMedia('(prefers-color-scheme: dark)').matches &&
              document.documentElement.getAttribute('data-nx-theme') !== 'off'
              ? 'https://zhanstatic.vivo.com.cn/wukong-zhan/img/72d9b178-9ac3-4abb-95c7-8fa315fe634fnwebp_compress.png'
              : 'https://zhanstatic.vivo.com.cn/wukong-zhan/img/5f6c7039-b400-4d5a-a60b-1e12cf423f2enwebp_compress.png'
        }
        // 采用公控的toast
        if (params.tips) {
          OSToast(params)
        }
      }
    }
  },
  openNewWebActivity({ url, header, error, success }) {
    if (env.isVivoApp && env.appVersion >= 4810) {
      try {
        // url 拼接参数，显示官网头
        url += (url.split('?')[1] ? '&' : '?') + 'show_title=1'
        window.WeiwoJSBridge.call('openNewWebActivity', {
          url
        })
      } catch (err) {
        error && error()
      }
    } else {
      error && error()
    }
  },
  // 打开新的webview，如果打开失败 是用1:router 跳转，2：location跳转
  openNewWebview({ url, type = 1 }) {
    if (!url) {
      return
    }
    if (env.isVivoApp) {
      if (env.appVersion >= 4810) {
        url += (url.split('?')[1] ? '&' : '?') + 'show_title=1'
        window.WeiwoJSBridge.call('openNewWebActivity', {
          url
        })
      } else {
        location.href = url
      }
    } else {
      location.href = url
      // if (type === 1) {
      //   let { pathname, search } = new URL(url)
      //   const routePath = pathname.replace('/wap', '')
      //   // 判断router path 是否在路由表中
      //   if (router.match(routePath).matched[0].path === routePath) {
      //     router.push(routePath + search)
      //   } else {
      //     location.href = url
      //   }
      // } else {
      //   location.href = url
      // }
    }
  },
  // 打开新的顶级webview，如果打开失败 是用1:router 跳转，2：location跳转
  openTopNewWebview({ url, type = 1 }) {
    if (!url) {
      return
    }
    if (env.isVivoApp) {
      if (env.appVersion >= 4810) {
        url += (url.split('?')[1] ? '&' : '?') + 'show_title=1'
        window.top.WeiwoJSBridge.call('openNewWebActivity', {
          url
        })
      } else {
        window.top.location.href = url
      }
    } else {
      window.top.location.href = url
    }
  },
  /**
   * 设置手机信号栏文字颜色
   */
  setStatusBarColor(color = 'white') {
    if (checkVersion(4810)) {
      window.WeiwoJSBridge.call('setStatusBarColor', { color: color }, function (value) {
        var result = JSON.parse(value)
      })
    }
  },

  /**
   * 唤起APP的电话
   * @param tel
   */
  callUp(tel = '') {
    window.vivospace.callUp(tel)
  },

  /**
   * 隐藏app title bar
   */
  setTitleBarVisible(commonImmersive = 1) {
    if (checkVersion(5010)) {
      window.WeiwoJSBridge.call('setTitleBarVisible', { commonImmersive })
    }
  },
  skipToHomePage() {
    if (checkVersion(1500)) {
      window.WeiwoJSBridge.call('skipToHomePage', {
        page_index: 0
      })
    } else {
      location.href = config.path.shopUrl + '/index.html'
    }
  },
  // 刷新webview
  reloadWebview() {
    if (checkVersion(6010)) {
      window.WeiwoJSBridge.call('loadInThisPage')
    } else {
      location.reload()
    }
  },
  // 通过浏览器打开指定的链接
  download(url) {
    if (env.isVivoApp && env.appVersion >= 190) {
      window.WeiwoJSBridge.download({
        url: url
      })
    }
  },
  // 创建离屏渲染模板
  preloadTemplate(query) {
    window.WeiwoJSBridge.call('preloadTemplate', {
      onlineKey: query?.key,
      onlineUrl: query?.url,
      notcompatiblity: '_NotCompatiblityHandler_'
    })
  },
  // 离屏渲染模板加载成功通知客户端
  templateLoadSuccess() {
    window.WeiwoJSBridge.call('onTemplateLoadSuccess', {
      notcompatiblity: '_NotCompatiblityHandler_'
    })
  },
  // 离屏渲染模板重置通知客户端
  templateDetachSuccess() {
    window.WeiwoJSBridge.call('onTemplateDetachSuccess', {
      notcompatiblity: '_NotCompatiblityHandler_'
    })
  },
  /**
   * @description 复制文案
   * @param {String} content
   */
  copyContent(content, cb) {
    if (env.isVivoApp) {
      window.WeiwoJSBridge.copy({ text: content })
      cb && cb()
      return
    }

    let oInput = document.createElement('input')
    oInput.value = content
    oInput.setAttribute('readonly', true)
    document.body.appendChild(oInput)
    oInput.select()
    document.execCommand('Copy')
    oInput.className = 'oInput'
    oInput.style.display = 'none'
    cb && cb()
  },
  /**
   * @description 设置分享弹层是否展示生成海报按钮
   * @param {Boolean} flag
   */
  setPosterShareStatus(flag) {
    if (checkVersion(920)) {
      window.WeiwoJSBridge.call('posterShareStatus', {
        isShow: flag
      })
    }
  },
  // 判断当前是否开启了深色模式，返回true：深色模式，false: 浅色模式
  getColorScheme() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
  },
  /**
   * @description 召回弹层
   * @param {String} title 弹层标题
   * @param {String} type 页面来源     order_refund： 退款详情、退货详情 | pay_over：支付成功
   */
  showNotifyRecallDialog({ title, type }) {
    const isVersion = env.appVersion == 6970 || env.appVersion == 6971 || env.appVersion >= 6996
    if (env.isVivoApp && isVersion && env.isVivoPhone) {
      window.WeiwoJSBridge.call('showNotifyRecallDialog', { title, type })
    }
  },
  // 外发app邀评弹窗
  showEvaluationDialog() {
    if (!env.isVivoPhone) {
      window.WeiwoJSBridge.call('showEvaluationDialog')
    }
  },
  /**
   * 获取模型及其它基本信息
   * @return {Object} 信息
   * {
   *   modelversion: 100, // 版本号
   *   birthday: '2000-10-10', // 生日
   *   model: 'vivo X90' // 手机型号
   *   age: 用户未设置传-1
   *   sex: 0未设置、1男、2女
   *   memory: 手机运存
   *   externalStorage: 手机存储
   *   isVivoPhone 是否是vivo手机
   * }
   */
  getInfoForModel(callback) {
    if (env.appVersion == 8180 || env.appVersion == 8181 || checkVersion(8200)) {
      window.WeiwoJSBridge.call('userInfoForModel', {}, res => {
        const result = JSON.parse(res)
        callback && callback(result)
      })
    }
  },
  /**
   * 获取AI推荐权重列表
   * @param {Object} data
   * @return {Object} 信息
   * {
   *    code: 0, // 成功
   *    phoneSkuIds:'1, 2, 3', // 手机skuid列表
   *    partSkuIds:'1, 2, 3'   // 配件skuid列表
   * }
   */
  modelInutdata(data, callback) {
    if (env.appVersion == 8180 || env.appVersion == 8181 || checkVersion(8200)) {
      window.WeiwoJSBridge.call('modelInPutdata', data, res => {
        const result = JSON.parse(res)
        callback && callback(result)
      })
    }
  },
  async getCallingPkg() {
    if (checkVersion(8400)) {
      const res = await new Promise((resolve, reject) => {
        window.WeiwoJSBridge.call('getCallingPkg', null, res => {
          resolve(res);
        });
      });
      return res;
    }
  },
  // 查询是否支持某个js方法 http://vjs.site.vmic.xyz/JsBridge/isSupportJSMethod/
  isSupportJSMethod(methodName) {
    let isSupport = false
    if (checkVersion(5500)) {
      WeiwoJSBridge.call('isSupportJSMethod', { 'methodName': methodName }, function (res) {
        isSupport = res === 'true' ? true : false
      })
    }
    return isSupport
  }
}
